import moment from 'moment'
import { Box, Grid, GridItem, Text, Tooltip } from '@chakra-ui/react'
import React from 'react'
import type { FolderDetailsResponse } from '../../../../interfaces'
import { useTranslation } from 'react-i18next'

interface FolderSummaryProps {
  folderDetails: FolderDetailsResponse
}

const FolderSummary: React.FC<FolderSummaryProps> = ({ folderDetails }) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Text fontWeight="600" mb="12px">
        {t('folder_info', 'Folder info')}
      </Text>

      <Grid
        templateColumns="120px 1fr"
        rowGap="12px"
        columnGap="16px"
        alignItems="center"
      >
        <GridItem>
          <Text color="#4b5a74">{t('last_modified', 'Last modified')}</Text>
        </GridItem>
        <GridItem>
          <Text fontWeight="500" className="updated-at">
            {folderDetails?.updatedAt
              ? moment(folderDetails.updatedAt).format('MMMM Do YYYY')
              : '-'}
          </Text>
        </GridItem>

        <GridItem>
          <Text color="#4b5a74">{t('created', 'Created')}</Text>
        </GridItem>
        <GridItem>
          <Text fontWeight="500" className="created-at">
            {folderDetails?.createdAt
              ? moment(folderDetails.createdAt).format('MMMM Do YYYY')
              : '-'}
          </Text>
        </GridItem>
      </Grid>
    </Box>
  )
}

export default FolderSummary
